export { default } from './SkeletonTravelsGuideContainerMobile';
